import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError, Observable} from 'rxjs';
import {GridGetService, GridServiceParams, GridServiceResponse} from 'src/app/shared/model/page-grid';
import {removeEmptyParams} from 'src/infrastructure/helper/remove-empty-params';
import {KtServicesFilterService} from './kt-services-filter.service';
import {IKtServiceListItem} from '../interfaces/kt-trip.interface';
import moment from 'moment';

@Injectable({providedIn: 'root'})
export class KtServicesGridService implements GridGetService<IKtServiceListItem> {
  private readonly baseUrl = 'tmt/sales-orders/kt-services';
  private readonly http = inject(HttpClient);
  private readonly filterService = inject(KtServicesFilterService);

  public salesOrderId: number | null = null;

  getItems({page, sort}: GridServiceParams): Observable<GridServiceResponse<IKtServiceListItem>> {
    const filters = this.filterService.filtersValue();

    const params: Record<string, string | number | boolean | string[] | number[]> = {
      pageSize: page?.pageSize || 25,
      pageNumber: (page?.pageIndex || 0) + 1,
      propertyName: sort?.active || '',
      orderKey: sort?.direction || '',
      tripReference: filters?.TripReference ?? '',
      serviceName: filters?.ServiceName ?? '',
      productTypeName: filters?.ProductTypeName ?? '',
      vendorName: filters?.VendorName ?? '',
      serviceStartDateFrom: filters?.ServiceStartDateFrom ? moment(filters.ServiceStartDateFrom).format('YYYY-MM-DD') : '',
      serviceStartDateTo: filters?.ServiceStartDateTo ? moment(filters.ServiceStartDateTo).format('YYYY-MM-DD') : '',
      ...(this.salesOrderId ? {salesOrderId: this.salesOrderId} : {}),
    };

    removeEmptyParams(params);

    return this.http.get<GridServiceResponse<IKtServiceListItem>>(this.baseUrl, {params: {...params}})
      .pipe(catchError((error: HttpErrorResponse) => {
        throw new Error(error?.message || 'Server error');
      }));
  }
}
